/* This is a component about the meme generator */
import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
function Meme() {
  const url = "https://api.imgflip.com/get_memes";
  const [allMemes, setAllMemes] = useState([]);
  const [meme, setMeme] = useState({
    topInput: "",
    bottomInput: "",
    topText: "",
    bottomText: "",
    randomImage: "http://i.imgflip.com/1bij.jpg"
  });
  const [image, setImage] = useState("");
  useEffect(function () {
    fetch(url)
      .then((res) => res.json())
      .then((data) => setAllMemes(data.data.memes));
  }, []);
  function handleChange(event) {
    const { name, value } = event.target;
    setMeme((prevMeme) => ({
      ...prevMeme,
      [name]: value
    }));
  }

  function changeImage(event) {
    const randomNumber = Math.floor(Math.random() * allMemes.length);
    const link = allMemes[randomNumber].url;
    setMeme((prevMeme) => ({
      ...prevMeme,
      randomImage: link
    }));
  }
  function saveImage() {
    const img = document.getElementById("download");
    html2canvas(img, { allowTaint: true, useCORS: true }).then(function (
      canvas
    ) {
      const imag = canvas.toDataURL("image/jpeg");
      saveAs(imag, `${meme.topText}.jpg`);
    });
  }
  function saveAs(uri, filename) {

    var link = document.createElement('a');

    if (typeof link.download === 'string') {

        link.href = uri;
        link.download = filename;

        //Firefox requires the link to be in the body
        document.body.appendChild(link);

        //simulate click
        link.click();

        //remove the link when done
        document.body.removeChild(link);

    } else {

        window.open(uri);

    }
}
  return (
    <div className="meme-container">
      <p><em>" Let's change the world, one meme at a time."</em></p>
      <div className="in-meme">
        

        <input
          id="topText"
          onChange={handleChange}
          name="topText"
          type="text"
          placeholder="Insert Top Text"
          />
        <input
          onChange={handleChange}
          id="bottomText"
          name="bottomText"
          type="text"
          placeholder="Insert Bottom Text"
          />

      </div>
        <button onClick={changeImage} className="meme-button">
          NAH, I'MA TRY ANOTHA ONE
        </button>
      <div id="download" className="img-container">
        <img
        alt="meme-pic"
          crossOrigin="anonymous"
          className="meme-img"
          src={meme.randomImage}
        />
        <h2 className="meme--text top">{meme.topText}</h2>
        <h2 className="meme--text bottom">{meme.bottomText}</h2>
      </div>
      <button onClick={saveImage} className="meme-button space">
        GET YOUR MAGNIFICENT MEME HERE
      </button>
      
    </div>
  );
}


function Footer(){
    return(
        <footer className ="footer">

            <p><span style={{color: "red", fontSize:"12px" }}>Need to open this page in your browser (chrome, safari, etc) for you to be able to download the meme.</span><br/><br/>The images are sourced from imgflip, I do not own any right to it. <br/>*Some images might not fit the Top/Bottom Text meme format.</p>
            <hr/>
            <div>
                <a href="https://www.instagram.com/mag.legrand/" target="_blank">
                    <span>                        
                        <i className="fa fa-instagram"></i>
                    </span>
                </a>
                <a href="https://www.linkedin.com/in/magmukendi/" target="_blank">
                    <span>                        
                        <i className="fa fa-linkedin"></i>
                    </span>
                </a>
                <a href="https://github.com/LeGrandMAG" target="_blank">
                    <span>                        
                        <i className="fa fa-github"></i>
                    </span>
                </a>
                <a href="https://twitter.com/MAGMukendi" target="_blank">
                    <span>                        
                        <i className="fa fa-twitter"></i>
                    </span>
                </a>
                <a href="https://www.facebook.com/mag.mukendi" target="_blank">
                    <span>                        
                        <i className="fa fa-facebook"></i>
                    </span>
                </a>
            </div>
                <p >© Mag Mukendi 2022</p>
        </footer>
    )
    
}

export  {Meme, Footer};
